import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as commonActions from './app.action';

import { DialogService } from 'primeng/dynamicdialog';
import { tap } from 'rxjs';
import { Router } from '@angular/router';
import { showMessage } from './app.action';
import { MessageService } from 'primeng/api';

@Injectable()
export class AppEffects {
  constructor(
    private actions$: Actions,
  private messageService: MessageService
  ) {}

  showMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(showMessage),
        tap(({key, severity, summary, detail }) => {
          this.messageService.add({ key, severity, summary, detail });
        })
      ),
    { dispatch: false }
  );
}
